import React from 'react'

const ZendeskIntegrationHeader = () => (
  <div className="admin-heading">
    <div className="ui stackable grid">
      <div className="eight wide column">
        <h2 className="mt0">Import Zendesk Satisfaction Ratings</h2>
      </div>
      <div className="eight wide column right aligned bottom aligned">
        <p>
          <a
            href="https://help.simplesat.io/en/articles/7154584-zendesk-integrations#h_94cac8629b"
            target="_blank"
            rel="noreferrer"
          >
            <i className="icon far fa-book" />
            Learn more about importing satisfaction ratings
          </a>
        </p>
      </div>
    </div>
  </div>
)

export default ZendeskIntegrationHeader



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/Admin/Integrations/ZendeskFeedbackImport/Headers/index.js